import React from "react";

const FormButton = () => {
  return (
    <button className="profile_btn w-full text-center sm:mt-6" type="submit">
      Update
    </button>
  );
};

export default FormButton;
